export default {
  ERROR_NOTIFICATION: 'error',
  INFO_NOTIFICATION: 'info',
  SUCCESS_NOTIFICATION: 'success'
};